import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Grid, ThemeConstellation } from '@zillow/constellation';

import { ModularListingContext } from '../../../containers/CreateListingPage/context';
import { WizardContext } from '../../Wizard/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../constants/WizardConstants';

import WizardAlert from '../../WizardAlert';
import PageWizard from '../../Wizard/PageWizard';

import RoomUtilitiesAmountFormField from './components/RoomUtilitiesAmountFormField';

import { WizardForm, WizardFormSectionContainer, WizardHeading } from '../../../styles/wizard';

const propTypes = {
  onGoToPrevStep: PropTypes.func.isRequired,
  onGoToNextStep: PropTypes.func.isRequired,
  wizardTitle: PropTypes.node.isRequired,
  progressStepper: PropTypes.node.isRequired,
  totalSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  showDesktopViewBreakpoint: PropTypes.oneOf(Object.keys(ThemeConstellation.ns().breakpoints)).isRequired,
};

const defaultProps = {};

const RoomUtilitiesAmount = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}) => {
  const {
    wizardState: { isFetchingData },
  } = useContext(WizardContext);

  const {
    modularListingState: { roomForRentFlow, serverErrorObj },
  } = useContext(ModularListingContext);

  const [clickedNext, setClickedNext] = useState(false);
  const [clickedBackNext, setClickedBack] = useState(false);

  useEffect(() => {
    const { fieldName } = serverErrorObj;

    if (!fieldName && !isFetchingData) {
      checkNavToStep();
    }
  }, [isFetchingData]);

  const checkNavToStep = () => {
    if (clickedNext) {
      onNextClick();
    }

    if (clickedBackNext) {
      onBackClick();
    }
  };

  const onNextClick = () => {
    if (isFetchingData) {
      setClickedNext(true);
      return;
    }

    onGoToNextStep();
  };

  const onBackClick = () => {
    if (isFetchingData) {
      setClickedBack(true);
      return;
    }

    onGoToPrevStep();
  };

  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="RoomUtilitiesAmount">
        <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

        <Grid
          display="grid"
          gridTemplateColumns={{
            default: 'repeat(6, 1fr)',
            // 769
            lg_gte: 'repeat(12, 1fr)',
          }}
          gap="sm"
        >
          <Grid gridColumnEnd={{ default: 'span 6', lg_gte: 'span 12', xl_gte: 'span 7', xxl_gte: 'span 7' }}>
            {/* cast as div to prevent cannot appear as a descendant of form error */}
            <WizardForm asChild={true} onSubmit={(e) => e.preventDefault()}>
              <div>
                <WizardFormSectionContainer data-testid="DescribeRoommates">
                  <WizardHeading level={1} textStyle="heading-sm">
                    What is the renter&apos;s share of the monthly utilities?
                  </WizardHeading>

                  <RoomUtilitiesAmountFormField />
                </WizardFormSectionContainer>
              </div>
            </WizardForm>
          </Grid>
        </Grid>
      </div>
    </PageWizard>
  );
};

RoomUtilitiesAmount.propTypes = propTypes;
RoomUtilitiesAmount.defaultProps = defaultProps;

export default RoomUtilitiesAmount;
